/* Vector & Grain — <vg-scroll-row>
   Prev/Next buttons for the horizontal tile row in the vg-landing-designs
   section. The track scrolls natively (swipe, trackpad, keyboard); the buttons
   only step it by one tile and disable themselves at either end. */
if (!customElements.get('vg-scroll-row')) {
  class VgScrollRow extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.update.bind(this);
      this.onPrev = () => this.step(-1);
      this.onNext = () => this.step(1);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-scroll-track]');
      this.prev = this.querySelector('[data-scroll-prev]');
      this.next = this.querySelector('[data-scroll-next]');
      if (!this.track) return;

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
    }

    step(direction) {
      const tile = this.track.firstElementChild;
      if (!tile) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * (tile.getBoundingClientRect().width + gap),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    update() {
      const track = this.track;
      if (!track) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (this.prev) this.prev.disabled = track.scrollLeft <= 1;
      if (this.next) this.next.disabled = track.scrollLeft >= maxScroll - 1;
    }
  }

  customElements.define('vg-scroll-row', VgScrollRow);
}
